var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bd-highlight w-100"},[_c('banner'),_vm._v(" "),_c('lux'),_vm._v(" "),_c('relax'),_vm._v(" "),_c('product'),_vm._v(" "),_c('blanket'),_vm._v(" "),_c('remove'),_vm._v(" "),_c('best'),_vm._v(" "),_c('strike'),_vm._v(" "),_c('div',{attrs:{"data-aos":"fade-up","data-aos-anchor-placement":"top-center"}},[_c('pauli')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14c3056d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page1/home.vue
// module id = 499
// module chunks = 0